module.exports = __webpack_public_path__ + "static/media/6274TwilightAve-Exterior.6fda5258.jpg";